import React from "react"

import Layout from "../components/en/Layout"

const AvistadosPage = props => (
  <Layout>
    <h1>Records &#128021; &#128008;</h1>
    <p>
      The main application screen has four tabs at the bottom. Each one accesses
      a specific function. The side menu remains accessible on the top right
      (&#9776;) and you can go back to the previous screen by the icon at the
      top left (&lt;).
    </p>
    <p>As funções principais são:</p>
    <p>
      <ul>
        <li>
          <strong>Events</strong> - You can post events and make announcements
          that will be seen by all users. When publishing, the app will also
          send notifications to all users who have notifications enabled. Each
          event has a start and end date. After the end date they will no longer
          appear on the list. The start date must be a maximum of 90 days and
          the validity period must be a maximum of 15 days.
        </li>
        <li>
          <strong>Rescue</strong> - Record the sighted animals as           
          lost and in need of rescue. Take a picture and inform            as
          many physical characteristics as possible. The records of           
          animals to be rescued are available to all who wish to assume their
                     guard putting them in adoption. In this case, they move to
          the            adoption screen under the new responsible user.
        </li>
        <li>
          <strong>Lost</strong> - Record lost animals being sought. There is a
          search option, which will search the database for records with the
          same physical characteristics.
        </li>
        <li>
          <strong>Adoption</strong> - Register animals for adoption. Here are
                     all animals placed for adoption by all guardians or
          protectors. They            also appear on the{" "}
          <strong>Guardians</strong>screen if you have            registered
          yoursef as a guardian. The adoption process can be done here,
                     identifying the destination home and the data of the person
          to adopt.
        </li>
      </ul>
    </p>
    <p>
      In all cases you can use the search bar at the top of the screen to filter
      records by email.
    </p>
  </Layout>
)

export default AvistadosPage
